((app) => {
    app.component("policyInfo", {
        templateUrl: "/App/States/Policies/Detail/PolicyInfo/policy.info.html",
        controller: "infoCardCtrl",
        bindings: {
            cardTitle: "@",
            isExpanded: "=",
            isDisabled: "=",
            data: "<",
            selectors: "<",
            query: "<"
        }
    });
})(window.app);